import {BaseComponent} from '@specials/gcs-engine';

import {SpaceshipAnimationComponent} from '../components/SpaceshipAnimationComponent';

export class ResultsSpaceshipAnimationManagerComponent extends BaseComponent {
  private animationComponent?: SpaceshipAnimationComponent;

  public onAddToWorld(): void {
    this.animationComponent = this.gameObject.getComponent(SpaceshipAnimationComponent);
  }

  public start(): void {
    this.animationComponent?.playCurrentAnimation();
  }

  public playClickAnimation(): void {
    const animationComponent = this.animationComponent;

    if (!animationComponent) return;

    const state = animationComponent.kotletkaCurrentState;

    if (animationComponent.reactionAnimation !== null || animationComponent.isSleepyState(state)) return;

    animationComponent.playHappyClickAnimation();
  }

  public playSoundClickByState(): void {
    this.animationComponent?.playHappySoundClick();
  }
}
